import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/AStarMaze.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-db530280"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<a id=\"maze\" data-v-db530280></a><div style=\"display:flex;flex-direction:column;align-items:center;\" data-v-db530280><h2 data-v-db530280>A* Algorithm with Recursive Backtracking</h2><p style=\"width:80vw;text-align:center;\" data-v-db530280> A* Maze is a C++ implementation of the A* search algorithm to navigate a maze generated with recursive backtracking. The program visualizes the pathfinding process, allowing users to observe how the algorithm explores the maze. </p><p style=\"width:80vw;text-align:center;\" data-v-db530280> The output of the maze soler is printed using ASCII characters in the terminal. <br data-v-db530280> For more details, checkout the github repo below. </p><a href=\"https://github.com/mgecawicz/AStarMaze/tree/main\" data-v-db530280><h3 data-v-db530280>A* Maze on GitHub 🔗</h3></a></div><div style=\"display:flex;flex-direction:column;align-items:center;\" data-v-db530280><img src=\"" + _imports_0 + "\" style=\"width:50%;\" data-v-db530280></div>", 3)
const _hoisted_5 = [
  _hoisted_2
]

import { ref, computed } from "vue";

import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "AStarMaze",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}
}

})